// extracted by mini-css-extract-plugin
export default {"table":"Table_table__Mvjo-","fadeInOut":"Table_fadeInOut__3pTQi"};